import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { RootState } from "../../store/store";
import { IRiskCategoryData, MitigationType } from "../../store/playbook-analysis-slice";
import { cn } from "../lib/utils";
import NoDocument from "../../utils/components/NoDocument";

export function Processed() {
	const processed = useSelector((state: RootState) => state.analysis.processed);

	if (!processed || processed.riskCount === 0) {
		return <NoDocument />;
	}

	return (
		<div className="py-4">
			<div className="rounded-lg px-3 py-0.5 grid w-fit justify-center items-center text-xs mx-2 bg-orange-50 text-orange-500">
				{processed.riskCount + " "}Track Changes
			</div>

			<ProcessedRows keyTerms={processed.risks} />
		</div>
	);
}

function ProcessedRows({ keyTerms }: { keyTerms: IRiskCategoryData["risks"] }) {
	return (
		<div>
			{keyTerms.map((keyTerm, idx) => (
				<Link to={`${idx}`} key={keyTerm.key}>
					{/*
					 * The paddding in y direction for the row is set to 20px to make it look consistent with the Analysis Rows.
					 * Because Analysis rows have a big Circle for the count we don't need same amount of padding and it has padding of 12px.
					 */}
					<div className="flex justify-between items-center gap-4 px-2 py-5 border-b border-gray-200 cursor-pointer text-xs">
						<div className="font-semibold">{keyTerm.key.replace(/\s*\(\d+\)$/, "")}</div>
						<div
							className={cn(
								"rounded-full grid items-center",
								keyTerm.values.at(0).comparison_type === MitigationType.CONTRADICTORY && "bg-red-50 text-red-500",
								keyTerm.values.at(0).comparison_type === MitigationType.MISSING && "bg-yellow-50 text-yellow-700"
							)}
						>
							{keyTerm.values.at(0).comparison_type === MitigationType.CONTRADICTORY ? "Risks" : "Missing"}
						</div>
					</div>
				</Link>
			))}
		</div>
	);
}
